var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFrame = function SvgFrame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#frame_svg__a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.823 13.812c.333-2.058.656-4.068.984-6.076.375-2.301.76-4.6 1.124-6.903.052-.324.162-.44.503-.44 4.858.012 9.715.015 14.573.001.39 0 .487.137.545.492.681 4.24 1.38 8.477 2.074 12.715.01.057.01.115.017.21h-2.586c.093-.471.163-.93.288-1.374.027-.098.25-.142.467-.252l-.974-5.962-.102.002c-.207 1.265-.415 2.529-.621 3.794-.188 1.151-.378 2.301-.558 3.453-.04.253-.117.382-.415.38-5.02-.008-10.04-.006-15.06-.007-.071-.002-.144-.019-.26-.033Zm16.02-11.82c-.165-.013-.265-.029-.365-.029-3.911-.001-7.822.003-11.732-.008-.348-.001-.443.129-.493.449-.389 2.447-.797 4.89-1.196 7.337-.134.826-.258 1.653-.393 2.521.182.01.326.025.47.025 3.851.001 7.703-.003 11.555.01.365 0 .513-.09.568-.469.202-1.386.442-2.767.666-4.15l.92-5.685Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.752 6.62c-.075.495-.121.906-.21 1.306-.023.1-.185.243-.283.243-2.494.007-4.987 0-7.481-.008-.012 0-.025-.015-.113-.07.069-.418.125-.878.236-1.325.02-.078.267-.139.409-.14 1.86-.01 3.72-.006 5.579-.006h1.863Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "frame_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.823 .299)",
    d: "M0 0h20v13.554H0z"
  })))));
};
export default SvgFrame;